import { gql } from './client';
import { realtime, SubscriptionHandlers } from './realtime';
import * as D from './graphql';
import type {
  Buddy,
  BuzzEvent,
  Message,
  Presence,
  PresenceEvent,
  TypingEvent,
  TypingState,
  User,
} from './types';

export const api = {
  me: () => gql<{ me: User }>(D.Q_ME).then((r) => r.me),

  getUser: (screenName: string) =>
    gql<{ getUser: User | null }>(D.Q_GET_USER, { screenName }).then((r) => r.getUser),

  buddyList: () =>
    gql<{ buddyList: { buddies: Buddy[] } }>(D.Q_BUDDY_LIST).then((r) => r.buddyList.buddies),

  /** Returns newest-first, as stored. Screens reverse for display. */
  conversation: (withWhom: string, limit = 50, nextToken?: string) =>
    gql<{ conversation: { items: Message[]; nextToken: string | null } }>(D.Q_CONVERSATION, {
      with: withWhom,
      limit,
      nextToken,
    }).then((r) => r.conversation),

  sendMessage: (to: string, body: string) =>
    gql<{ sendMessage: Message }>(D.M_SEND_MESSAGE, { to, body }).then((r) => r.sendMessage),

  setPresence: (presence: Presence, awayMessage?: string | null) =>
    gql<{ setPresence: PresenceEvent }>(D.M_SET_PRESENCE, {
      presence,
      awayMessage: awayMessage ?? null,
    }).then((r) => r.setPresence),

  setTyping: (to: string, state: TypingState) =>
    gql<{ setTyping: TypingEvent }>(D.M_SET_TYPING, { to, state }).then((r) => r.setTyping),

  buzz: (to: string) => gql<{ buzz: BuzzEvent }>(D.M_BUZZ, { to }).then((r) => r.buzz),

  addBuddy: (screenName: string, group?: string) =>
    gql<{ addBuddy: Buddy }>(D.M_ADD_BUDDY, { screenName, group: group ?? null }).then(
      (r) => r.addBuddy
    ),

  removeBuddy: (screenName: string) =>
    gql<{ removeBuddy: boolean }>(D.M_REMOVE_BUDDY, { screenName }).then((r) => r.removeBuddy),

  updateProfile: (profileText: string) =>
    gql<{ updateProfile: User }>(D.M_UPDATE_PROFILE, { profileText }).then((r) => r.updateProfile),
};

export const subscribe = {
  messages: (myScreenName: string, h: SubscriptionHandlers<Message>) =>
    realtime.subscribe(D.S_ON_MESSAGE, { to: myScreenName }, 'onMessage', h),

  presence: (screenName: string, h: SubscriptionHandlers<PresenceEvent>) =>
    realtime.subscribe(D.S_ON_PRESENCE, { screenName }, 'onPresence', h),

  typing: (myScreenName: string, h: SubscriptionHandlers<TypingEvent>) =>
    realtime.subscribe(D.S_ON_TYPING, { to: myScreenName }, 'onTyping', h),

  buzz: (myScreenName: string, h: SubscriptionHandlers<BuzzEvent>) =>
    realtime.subscribe(D.S_ON_BUZZ, { to: myScreenName }, 'onBuzz', h),
};
